import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import type { User } from '@/lib/data';

interface AuthState {
  isLoading: boolean;
  setIsLoading: (loading: boolean) => void;
  isAuthenticated: boolean;
  setIsAuthenticated: (isAuthenticated: boolean) => void;
  user: User | null;
  setUser: (user: User | null) => void;
}

export const useAuthStore = create<AuthState>()(
  devtools(
    (set) => ({
      isLoading: true,
      setIsLoading: (isLoading) => set({ isLoading }, false, 'setIsLoading'),
      isAuthenticated: false,
      setIsAuthenticated: (isAuthenticated) =>
        set({ isAuthenticated }, false, 'setIsAuthenticated'),
      user: null,
      setUser: (user) => set({ user }, false, 'setUser'),
    }),
    { name: 'auth-store' },
  ),
);
